/**
 * Created by vladislav on 7/11/2025
 */

const BaseSender = function () {

};

BaseSender.prototype.send = function (push, timeout) {};

BaseSender.prototype.cancel = function (id) {};

BaseSender.prototype.askPermissions = function (options, callback) {
    callback(connector.CODE_SUCCEED, true);
};